// Clubs which do not have MyQuote Link
export const clubsWithNoMyQuoteLink = [
  '115',
  '130',
  '195',
  '222',
  '238',
  '104',
];
